import type { Order } from "../../../../../../../services";

const cellProcessing = (item: Order.Model["counterparty"]): string =>
	item?.additionalFields?.name ?? "";

export default cellProcessing;
